<template>
  <div class="row" v-if="this.users.length > 0">
    <table class="table table-striped">
      <thead>
        <tr>
          <th>ID</th>
          <th>E-mail</th>
          <th>First Name</th>
          <th>Last Name</th>
          <th>Klaviyo</th>
          <th>Locked</th>
          <th>Deleted</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in users" :key="row.id" style="line-height: 35px;">
          <td>{{ row.id }}</td>
          <td>{{ row.email }}</td>
          <td>{{ row.firstname }}</td>
          <td>{{ row.lastname }}</td>
          <td>
            <a :href="`https://www.klaviyo.com/profile/${row.klaviyoProfileId}`" target="_blank">{{
              row.klaviyoProfileId
            }}</a>
          </td>
          <td><input class="form-check-input" type="checkbox" :checked="row.isLocked" disabled /></td>
          <td><input class="form-check-input" type="checkbox" :checked="row._isDeleted" disabled /></td>
          <td>
            <button
              class="btn btn-outline-secondary"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Change Email Address"
              v-on:click="loadEmailChange(row.id, row.email)"
            >
              <i class="bi bi-envelope-fill"></i>
            </button>
            &nbsp;
            <button
              class="btn btn-outline-secondary"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Unlock User"
              v-on:click="loadUserUnlock(row.id, row.email)"
            >
              <i class="bi bi-unlock-fill"></i>
            </button>
            &nbsp;
            <a class="btn btn-outline-secondary" :href="`https://metabase.api.gofar.co/question/93-mobile-app-health-logs-by-user?userid=${row.id}`" target="_blank"><i class="bi bi-clipboard2-pulse-fill"></i></a>
            &nbsp;
            <a class="btn btn-outline-secondary" :href="`/admin/user/${row.id}/vehicles`" target="_blank"><i class="bi bi-car-front-fill"></i></a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'UsersTabular',
  props: {
    users: []
  },
  methods: {
    loadEmailChange(userId, email) {
      this.$emit('loadEmailChange', userId, email);
    },
    loadUserUnlock(userId, email) {
      this.$emit('loadUserUnlock', userId, email);
    }
  }
}
</script>
